import { useEffect, useState } from "react";
import { FormikProvider, useFormik } from "formik";
import { DetailsImageVehicleRow } from "../../fields-upload/DetailsImageVehicleRow";
import { IMaintenanceVisualRecord } from "../../../../../../types/maintenance-visual-record.type";
import { brDateHourFormat } from "../../../../../../common/helpers/date.helpers";
import { FaCheck, FaPencilAlt } from "react-icons/fa";
import { addMaintenanceObservation } from "@/common/services/maintenance.api";
import ModalAddPhotosMaintenance from "../../modals/ModalAddPhotosMaintenance";

type NewType = {
  data: IMaintenanceVisualRecord;
  onClose?: () => void;
};

type VehicleEndMaintenanceDetailsProps = NewType;
export default function VehicleEndMaintenanceDetails(
  props: VehicleEndMaintenanceDetailsProps
) {
  const [vehicleId, setvehicleId] = useState<string | null>(null);

  const [isAddingObservation, setIsAddingObservation] = useState(false);
  const [newObservationText, setNewObservationText] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const [action, setAction] = useState<{
    eventName: string;
    data: IMaintenanceVisualRecord;
  }>();
  const [data, setData] = useState(props.data);

  const formik = useFormik({
    initialValues: {
      endMaintenance: data.photosMaintenance[0]?.endMaintenance || [],
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      values;
    },
  });

  useEffect(() => {
    if (props.data !== undefined) {
      props.data && setvehicleId(vehicleId);
    }
  }, [props.data, vehicleId]);

  const handleSaveObservation = async () => {
    if (!data._id || !newObservationText.trim() || isSaving) return;

    setIsSaving(true);
    try {
      const result = await addMaintenanceObservation(
        data._id,
        newObservationText
      );

      if (result.ok && result.data) {
        setData(result.data);
        setNewObservationText("");
        setIsAddingObservation(false);
      } else {
        alert("Erro ao salvar a observação: " + result.message);
      }
    } catch (error) {
      console.error("Erro ao salvar a nova observação:", error);
      alert("Erro ao salvar a observação. Verifique o console.");
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    if (!action?.data) {
      return;
    }
    setData(action.data);
    formik.resetForm({
      values: {
        ...formik.values,
        endMaintenance: action.data.photosMaintenance[0]?.endMaintenance || [],
      },
    });
  }, [action, formik]);

  const isAction = (eventName: string) => action?.eventName === eventName;

  return (
    <div className="fixed inset-0 z-10 bg-black bg-opacity-30 flex justify-center items-center p-4">
      <FormikProvider value={formik}>
        <section
          style={{ backgroundColor: "rgb(179, 175, 175)" }}
          className=" flex flex-col items-center rounded-md shadow-lg min-w-[40%] max-w-[90%] md:max-w-2xl mx-auto p-4 max-h-[calc(100vh-4rem)] overflow-auto"
        >
          <h2 className="text-2xl font-semibold mb-4">
            Detalhes da Manutenção Finalizada
          </h2>
          <div className="flex flex-wrap justify-center">
            {data.photosMaintenance[0]?.endMaintenance?.map((doc, index) => (
              <div
                key={index}
                className={`flex flex-col space-y-2 p-3 my-0 rounded ${
                  index % 2 ? "bg-gray/5" : "bg-gray/5"
                }`}
              >
                <DetailsImageVehicleRow
                  name={`endMaintenance.${index}`}
                  initialData={doc || {}}
                  prefix="end-maintenance"
                  vehicleId={data.vehicleId}
                />
              </div>
            ))}
          </div>

          <div className="flex justify-around w-full mb-4">
            <button
              onClick={() => {
                if (data._id) {
                  setAction({ eventName: "addFileMaintenanceEnd", data: data });
                } else {
                  alert("ID do Registro de Manutenção ausente.");
                }
              }}
              className="bg-redPrimary text-white w-34 border-black border-opacity-30 shadow-md relative self-end"
            >
              Adicionar Fotos
            </button>
          </div>
          <div className="w-full sm:w-[70%] h-auto min-h-[200px] p-2 rounded-md shadow-lg mb-8 bg-white/50 text-black overflow-auto">
            <p className="font-bold">
              `Tipo de Manutenção: {data.maintenanceType}`
            </p>

            <p className="font-bold">Peças alteradas: </p>
            {data.budgetlabel.map((piece) => (
              <div key={piece.name} className="mb-2">
                <span className="font-semibold">{piece.name}</span>, Quantidade:{" "}
                {piece.quantity}, Tipo: {piece.type}, Preço unitário:{" "}
                {piece.price}
              </div>
            ))}
            <p className="font-bold">Mecânico Responsável:</p>
            <p>{data.mechanic}</p>
            <p className="font-bold">Hodômetro do Veículo:</p>
            <p>{data?.odometer}Km</p>
          </div>

          <div className="w-full sm:w-[70%] h-auto min-h-[200px] p-2 rounded-md shadow-lg mb-8 bg-white/50 text-black overflow-auto relative">
            <div className="flex justify-between items-center mb-4">
              <p className="font-bold">Observações:</p>
              {!isAddingObservation && (
                <button
                  onClick={() => {
                    setIsAddingObservation(true);
                    setNewObservationText("");
                  }}
                  className="bg-red-500 text-white px-3 py-1 text-sm rounded flex items-center shadow-md hover:bg-red-600"
                  title="Adicionar Nova Observação"
                >
                  <FaPencilAlt className="w-3 h-3 mr-1" /> Adicionar
                </button>
              )}
            </div>

            {isAddingObservation && (
              <div className="flex flex-col space-y-2 mb-6 p-3 bg-white/70 rounded-md shadow-inner">
                <p className="font-semibold">Nova Observação:</p>
                <textarea
                  className="w-full p-2 border border-gray-400 rounded-md h-24 resize-none"
                  value={newObservationText}
                  onChange={(e) => setNewObservationText(e.target.value)}
                  placeholder="Digite o texto da nova observação de manutenção."
                />
                <div className="flex justify-end space-x-2">
                  <button
                    onClick={() => setIsAddingObservation(false)}
                    className="bg-gray-500 text-white px-4 py-2 rounded text-sm"
                    disabled={isSaving}
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleSaveObservation}
                    className="bg-green-600 text-white px-4 py-2 rounded text-sm flex items-center"
                    disabled={isSaving || !newObservationText.trim()}
                  >
                    {isSaving ? (
                      <>
                        <svg
                          className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Salvando...
                      </>
                    ) : (
                      <>
                        <FaCheck className="w-3 h-3 mr-2" />
                        Salvar
                      </>
                    )}
                  </button>
                </div>
              </div>
            )}

            {data.maintenanceObservation
              ?.slice()
              .reverse()
              .map((observation, index) => (
                <div
                  key={index}
                  className="w-full bg-gray/10 my-4 p-2 rounded-md border border-gray/40"
                >
                  <label className="font-semibold">
                    {brDateHourFormat(observation.date)}
                  </label>
                  <p className="whitespace-pre-wrap">
                    <h3 className="font-semibold">Observação:</h3>
                    {observation.text}
                  </p>
                  <br />
                  <p className="font-semibold">
                    Criado por: {observation.author}
                  </p>
                </div>
              ))}
          </div>
          <button
            onClick={props.onClose}
            className="bg-redPrimary text-white w-24 border-black border-opacity-30 shadow-md relative self-end"
          >
            Fechar
          </button>
        </section>

        {isAction("addFileMaintenanceEnd") && data._id && (
          <ModalAddPhotosMaintenance
            docType="end-maintenance"
            onClose={() => setAction(undefined)}
            vehicleId={data.vehicleId}
            visualRecordId={data._id as string}
            closeAndUpdate={(updatedData) =>
              setAction({ eventName: "photosAdded", data: updatedData })
            }
          ></ModalAddPhotosMaintenance>
        )}
      </FormikProvider>
    </div>
  );
}
